
const a_Page_Data = [
    ['About Us', 'about-us'],
    ['Contact Us', 'contact-us'],
    ['Expert Team', 'expert-team'],
    ['Latest News', 'latest-news'],
    ['FAQs', 'faqs'],
    ['Terms And Conditions', 'terms-and-condition'],
    ['Privacy Policy', 'privacy-policy'],
    
];
export default a_Page_Data;